import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import {
  fetchGetUserDataByRequest,
  IGetUserDataByRequestResponse200 as IRes200,
  IGetUserDataByRequestResponse400 as IRes400,
} from '../../repositories/monolith-python/v1/get-user-data-by-request';
import { setUserData } from './actions';

export const getUser = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const {
    page: { subdomain },
  } = getState();

  try {
    const res = await fetchGetUserDataByRequest<IRes200, IRes400>({
      httpApi: context.httpApi,
      config: { subdomain },
      parameters: {},
    });

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        domain: 'getUser.ts',
        statusCode: res.statusCode,
        message: res.response.message,
        details: { errors: res.response.errors },
      });
    }

    const { user } = res.response.data;

    if (user && user.isAuthenticated) {
      const phone = user.phones?.length ? user.phones[0].phone : '';
      dispatch(
        setUserData({
          userId: user.userId,
          email: user.email,
          isAuthenticated: true,
          phone,
          isAgent: user.isAgent,
        }),
      );
    }
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('get-user-data-by-request BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in get-user-data-by-request' });
    }
  }
};
